import { v as bvVar } from 'bv';
import boot from './boot';
import showServiceManager from './service/service_manager';
import liveChatApp from './live_chat_app';

let bootZendesk;

const bootService = () => {
  if (!bootZendesk) bootZendesk = boot();
};

const showService = (service) => {
  if (!bootZendesk) bootZendesk = boot();

  bootZendesk.then(() => showServiceManager(service));
};

const liveChat = () => {
  if (bvVar('zendeskConfig').useWebSDK) {
    liveChatApp();
  } else {
    showService('chat');
  }
};

export {
  bootService,
  showService,
  liveChat,
};
